<template>
  <div>
    <v-dialog
      v-model="exchange_dialog"
      max-width="500px"
      transition="dialog-transition"
      scrollable
      persistent
    >
      <v-card v-if="exchange_dialog && one_exchange.id">
        <v-card-title class="blue-grey white--text py-0">
          <v-row>
            <v-col cols="1" class="d-flex justify-center">
              <v-icon dark @click="$emit('close')">mdi-close</v-icon>
            </v-col>
            <v-col>
              Permuta:
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form readonly>
            <v-row justify="center">
              <v-col>
                <v-text-field label="Cliente" :value="one_exchange.client_name"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="5">
                <v-text-field label="Criado em" :value="$moment(one_exchange.created_at.substring(0,10)).format('L')"></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-text-field label="Total" :value="one_exchange.ammount.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between" v-if="one_exchange.status_id == status_id_map['Confirmed']">
              <v-col cols="5">
                <v-text-field label="Confirmado por" :value="one_exchange.confirmed_by_name"></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-text-field label="Confirmado em" :value="$moment(one_exchange.confirmed_at.substring(0,10)).format('L')"></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row justify="center">
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- para a pagina de abertos quando não confirmado -->
          <v-col cols="6" class="d-flex justify-center" v-if="one_exchange.status_id == status_id_map['Payed']">
            <v-btn color="error" width="100%" rounded @click="deleteExchange()"><v-icon left>mdi-alert-circle</v-icon>Excluir</v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-center" v-if="one_exchange.status_id == status_id_map['Payed']">
            <v-btn color="primary" width="100%" rounded @click="confirmExchange()"><v-icon left>mdi-check-bold</v-icon>Confirmar</v-btn>
          </v-col>
          <!-- para a pagina abertos quando confirmado -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <edit-exchange-dialog :edit_dialog="edit_dialog" :exchange="one_exchange" @closeEditDialog="handleCloseEditDialog" @doneUpdate="handleDoneUpdate"></edit-exchange-dialog> -->
    <!-- <problem-dialog v-if="problem_dialog" :problem_dialog="problem_dialog" :exchange="one_exchange" @doneReturned="handleDoneReturned" @closeDialog="handleCloseDialog" ></problem-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'ExchangeDialog',
  mixins: [ status ],
  components: {
    // AttachDoc: () => import('../../shipping/driver/AttachDoc'),
    // EditExchangeDialog: () => import('./EditExchangeDialog'),
    // ProblemDialog: () => import('./ProblemDialog'),
  },
  props: {
    exchange: {
      type: Object
    },
    exchange_dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      edit_dialog: false,
      one_exchange: {},

      new_attach: false,
      new_document: {},

      problem_dialog: false,
    }
  },
  methods: {
    deleteExchange(){
      let c = confirm('Certeza em DELETAR o depósito?')

      if (c){
        const {id, } = this.one_exchange
        this.deleteExchange(id)
      }
    },
    confirmExchange(){
      let c = confirm('Certeza em CONFIRMAR o depósito?')

      if (c){
        const {id, } = this.one_exchange
        let obj = {
          id,
          status_id: this.status_id_map['Confirmed'],
          confirmed_at: new Date().toISOString().substring(0,10),
          confirmed_by_id: this.current_user_employee_id,
        }
        this.updateExchange(obj, true)
      }
    },
    handleCloseDialog(){
      this.problem_dialog = false
    },
    problemExchange(){
      this.problem_dialog = true
    },
    handleDoneReturned(e){
      this.problem_dialog = false
      this.$emit('doneReturned')
    },
    concludeExchange(){
      let c = confirm('Certeza em CONCLUIR o depósito?')

      if (c){
        const {id, } = this.one_exchange
        let obj = {
          id,
          status_id: this.status_id_map['Concluded'],
          
          concluded_at: new Date().toISOString().substring(0,10),
          concluded_by_id: this.current_user_employee_id,
        }
        this.updateExchange(obj, true)
      }
    },
    updateExchange(obj, with_emit = false){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      Api.Exchange.update(obj).then(r => r.data).then(r => {
        this.one_exchange = {
          ...this.one_exchange,
          ...r,
        }
        if (with_emit){
          this.$emit('doneUpdate')
        }
      }).catch(error => {
        console.log(error)
        noti = {
          type: 'error',
          msg: `Erro: ${error}`
        }
      }).finally(()=>{
        this.loading_saving = false
        this.addNotification(noti)
      })
    },
    deleteExchange(id){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      Api.Exchange.delete(id).then(r => r.data).then(r => {
        this.$emit('doneDelete')
      }).catch(error => {
        console.log(error)
        noti = {
          type: 'error',
          msg: `Erro: ${error}`
        }
      }).finally(()=>{
        this.loading_saving = false
        this.addNotification(noti)
      })
    },
    setupOneExchange(){
      this.one_exchange = {
        ...this.exchange
      }
    },
    submitNewAttach(){
      const {id, } = this.one_exchange
      let obj = {
        id, 
        document: this.new_document
      }
      this.updateExchange(obj)
    },
    handleDoneDoc(e) {
      this.new_attach = true
      this.new_document = {...e}
    },
    handleRemoveDoc(){
      this.$emit('removeDoc')
      this.new_attach = false
      this.new_document = {}
    },
    editDialog() {
      this.edit_dialog = true
    },
    handleCloseEditDialog() {
      this.edit_dialog = false
    },
    handleDoneUpdate(e) {
      this.one_exchange = {
        ...e
      }
      this.edit_dialog = false
      this.$emit('doneUpdate')
    },
    ...mapActions({
      
    }),
  },
  computed: {
    ...mapState({
      profile: state => state.User.oneUser,
    }),
  },
  watch: {
    exchange_dialog(nv) {
      if (nv) {
        this.setupOneExchange()
      }
    }
  },
}
</script>
